import React from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/ApiService';

type ReturningUserSignInProps = {
  surface: 'hero' | 'final';
  className?: string;
};

/**
 * Quiet returning-user path. Primary conversion stays “Start your garage”.
 * Copy matches the invite landing: “Already have a garage? Sign in”.
 */
export const ReturningUserSignIn: React.FC<ReturningUserSignInProps> = ({
  surface,
  className = '',
}) => (
  <p className={`text-sm text-gray-400 ${className}`.trim()}>
    Already have a garage?{' '}
    <Link
      to="/login"
      className="font-medium text-orange-400 hover:text-orange-300 underline-offset-2 hover:underline transition-colors duration-200 rounded cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/50"
      onClick={() => {
        void apiService.trackEvent('home_cta_clicked', {
          metadata: { cta: 'sign_in', surface },
        });
      }}
    >
      Sign in
    </Link>
  </p>
);

export default ReturningUserSignIn;
